import React, { useEffect, useState } from 'react';
export function StickyTopBar() {
  const [timeLeft, setTimeLeft] = useState(10 * 60);
  const [hasReset, setHasReset] = useState(false);
  const [isUrgent, setIsUrgent] = useState(false);
  const [showTimer, setShowTimer] = useState(true);
  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(prev => {
        if (prev > 0) return prev - 1;
        if (!hasReset) {
          setHasReset(true);
          setIsUrgent(true);
          return 10 * 60;
        } else {
          setShowTimer(false);
          return 0;
        }
      });
    }, 1000);
    return () => clearInterval(timer);
  }, [hasReset]);
  const minutes = Math.floor(timeLeft / 60);
  const seconds = timeLeft % 60;
  const timeString = `${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`;
  const scrollToOffer = (e: React.MouseEvent) => {
    e.preventDefault();
    document.getElementById('oferta')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <div className={`fixed top-0 left-0 right-0 z-50 ${isUrgent ? 'bg-red-600' : 'bg-brand-purpleDark'} text-white py-2.5 px-4 shadow-lg transition-colors duration-500`} data-id="element-203">
      <div className="max-w-6xl mx-auto flex flex-wrap items-center justify-between gap-2 text-sm sm:text-base font-medium" data-id="element-204">
        <span className="flex items-center gap-1" data-id="element-205">
          {isUrgent ? '⏰' : '⚡'}{' '}
          {isUrgent ? 'Última oportunidad' : 'Oferta especial'}
        </span>

        {showTimer && <div className="bg-brand-yellow text-brand-purpleDark px-3 py-1 rounded-md font-bold" data-id="element-206">
            {timeString}
          </div>}

        <div className="flex items-center gap-3" data-id="element-207">
          <div className="flex items-center gap-2" data-id="element-208">
            <span className="line-through opacity-70 text-sm" data-id="element-209">$30.000</span>
            <span className="text-brand-yellow font-bold" data-id="element-210">$6.999</span>
          </div>
          <button onClick={scrollToOffer} className="bg-brand-yellow text-brand-purpleDark px-3 py-1 rounded-md font-bold text-sm hover:bg-[#E5B515] transition-colors" data-id="element-211">
            Comprar ↓
          </button>
        </div>
      </div>
    </div>;
}